var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearedIcon = function SvgClearedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 0L39.9186 11.5V34.5L20 46L0.0814152 34.5V11.5L20 0Z",
    fill: "#138634"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_6152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 33C25.5228 33 30 28.5228 30 23C30 17.4772 25.5228 13 20 13C14.4772 13 10 17.4772 10 23C10 28.5228 14.4772 33 20 33Z",
    stroke: "#02542D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_6152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 11)"
  })))));
};
export { SvgClearedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/b3b7cd34.svg";